import { Component, ChangeDetectionStrategy } from '@angular/core';
import {AuthService} from '../../services/auth.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class NavComponent {

  constructor(
    public authService: AuthService
  ) { }

  logout() {
    this.authService.logout();
  }
}
